export const SET_WORDS = 'SET_WORDS';
export const ADD_WORD  = 'ADD_WORD';
export const ADD_SUGGESTION = 'ADD_SUGGESTION';
export const REMOVE_WORD = 'REMOVE_WORD';
export const SET_RANDOMNESS = 'SET_RANDOMNESS';
export const SET_WORDS_LENGTH = 'SET_WORDS_LENGTH';
export const SET_GENERATED_WORDS = 'SET_GENERATED_WORDS';
export const SET_RECOMMENDED_WORDS = 'SET_RECOMMENDED_WORDS';
export const SET_DOMAIN_CHECKS = 'SET_DOMAIN_CHECKS';
export const SET_DOUBLEMEANING_CHECK = 'SET_DOUBLEMEANING_CHECK';
export const SET_RECOMMENDATIONS_LOADING = 'SET_RECOMMENDATIONS_LOADING';
export const SET_DOMAINS_LOADING = 'SET_DOMAINS_LOADING';
export const TOGGLE_DICTIONARY_MODE = 'SET_DICTIONARY_MODE';
export const TOGGLE_DOMAIN_AVAILABILITY_FILTER = 'TOGGLE_DOMAIN_AVAILABILITY_FILTER';
